import {
    ActionIcon,
    Badge,
    Box,
    Button,
    Checkbox,
    Flex,
    Group,
    Stack,
    Text,
} from '@mantine/core';

import FiltersMultiSelect from '../../../../common/filtersMultiSelect/FiltersMultiSelect';
import { IconPlus } from '@tabler/icons-react';
import { NavLink } from 'react-router-dom';

const ChatScriptTableToolbar = ({
    filterOptions,
    rightSection,
    actionButtons: ToolbarActions,
    showHidden,
    toggleShowHidden,
}) => {
    return (
        <>
            <Group
                ms={'xs'}
                gap={'xs'}
                align='flex-start'
                w={'100%'}>
                <FiltersMultiSelect options={filterOptions} />
            </Group>
            <Flex
                px={'md'}
                w={'100%'}
                align={'bottom'}
                justify={'flex-end'}>
                <NavLink to={'/campaigns/scripts/create'}>
                    <Button
                        size={'compact-xs'}
                        leftSection={
                            <IconPlus
                                style={{ width: '70%', height: '70%' }}
                                stroke={1.5}
                            />
                        }
                        styles={{
                            section: {
                                marginInlineEnd: 0,
                            },
                        }}>
                        New Script
                    </Button>
                </NavLink>
            </Flex>
            {rightSection}
        </>
    );
};
export default ChatScriptTableToolbar;
